<template>
  <transition :name="transition">
    <div v-if="isVisible" :class="panelClass" :style="panelStyle">
      <slot></slot>
    </div>
  </transition>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '400px',
    },
    maxWidth: {
      type: String,
      default: '500px',
    },
    minWidth: {
      type: String,
      default: '300px',
    },
    position: {
      type: String,
      default: 'right',
      validator: (value) => ['left', 'right'].includes(value),
    },
    transition: {
      type: String,
      default: 'slide-left',
    },
    customClass: {
      type: String,
      default: '',
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const isVisible = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
  });

  const panelClass = computed(() => {
    const classes = ['details-side-panel', 'col-4'];
    if (props.customClass) {
      classes.push(props.customClass);
    }
    return classes.join(' ');
  });

  const panelStyle = computed(() => ({
  // Remove fixed width constraints to let col-4 control the width
  }));
</script>

<style scoped>
.details-side-panel {
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;
}

/* Slide from right */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease;
}

.slide-left-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Slide from left */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}

.slide-right-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
